import { useState } from 'react';
import Notification from '@/components/ui/Notification';
import AuthSecurityTab from '@/components/admin/ProfileSettings/AuthSecurityTab';
import AccountInformationTab from '@/components/admin/ProfileSettings/AccountInformationTab';
import SportPreferencesTab from '@/components/admin/ProfileSettings/SportPreferences';
import {
  AkunTab,
  DataArenaTab,
  OperasionalTab,
  PenanggungJawabTab,
} from '@/components/admin/ProfileSettings';
import { Icon } from '@iconify/react';

const ProfileSettings = (page: string) => {
  const [notification, setNotification] = useState({
    isOpen: false,
    message: '',
    variant: 'success' as 'success' | 'error',
  });

  const [activeTab, setActiveTab] = useState<string>(
    page === 'admin' ? 'data-arena' : 'account-information'
  );

  const handleSubmit = async (values: any, tabId: string) => {
    try {
      console.log(`Submitting ${tabId}:`, values);
      setNotification({
        isOpen: true,
        message: 'Perubahan berhasil disimpan!',
        variant: 'success',
      });
    } catch (_error) {
      setNotification({
        isOpen: true,
        message: 'Gagal menyimpan perubahan data',
        variant: 'error',
      });
    }
  };

  let tabs: { id: string; label: string; content: React.ReactNode }[] = [];
  if (page === 'admin') {
    tabs = [
      {
        id: 'data-arena',
        label: 'Informasi Arena',
        content: <DataArenaTab onSubmit={handleSubmit} />,
      },
      {
        id: 'penanggung-jawab',
        label: 'Kontak',
        content: <PenanggungJawabTab onSubmit={handleSubmit} />,
      },
      {
        id: 'operasional',
        label: 'Operasional',
        content: <OperasionalTab onSubmit={handleSubmit} />,
      },
      {
        id: 'akun',
        label: 'Akun',
        content: <AkunTab onSubmit={handleSubmit} />,
      },
    ];
  } else if (page === 'client') {
    tabs = [
      {
        id: 'account-information',
        label: 'Informasi Akun',
        content: <AccountInformationTab />,
      },
      {
        id: 'sport-preference',
        label: 'Preferensi Olahraga',
        content: <SportPreferencesTab onSubmit={handleSubmit} />,
      },
      {
        id: 'auth',
        label: 'Keamanan & Login',
        content: <AuthSecurityTab onSubmit={handleSubmit} />,
      },
    ];
  }

  const activeContent = tabs.find((t) => t.id === activeTab)?.content || tabs[0]?.content;

  return (
    <>
      <div className="p-4 sm:p-6 lg:p-8 space-y-6 max-w-8xl mx-auto">
        {/* Header (Matching Screenshot: Profil title on left, Simpan Perubahan on right) */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="md:hidden p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 cursor-pointer"
              onClick={() => window.history.back()}
            >
              <Icon icon="ph:arrow-left-bold" className="w-5 h-5" />
            </button>
            <h1 className="text-xl md:text-2xl font-semibold text-[#0E1726]">Profil</h1>
          </div>

          <button
            type="submit"
            form="active-profile-form"
            className="bg-[#FC480D] hover:bg-[#E8490F] text-white text-xs md:text-sm font-semibold px-6 py-2.5 rounded-full shadow-2xs active:scale-[0.98] transition-all cursor-pointer"
          >
            Simpan Perubahan
          </button>
        </div>

        {/* Tab Switcher (Horizontal Pill / Text as in Screenshots 1, 2, 3) */}
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar py-1">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 rounded-full text-xs font-semibold transition-all cursor-pointer shrink-0 ${
                  isActive
                    ? 'bg-white text-[#FC480D] border border-orange-200/80 shadow-2xs'
                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100/60'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Active Tab Form Content */}
        <div className="pt-2">{activeContent}</div>
      </div>

      {/* Notification Toast */}
      <Notification
        isOpen={notification.isOpen}
        onClose={() => setNotification({ ...notification, isOpen: false })}
        message={notification.message}
        variant={notification.variant}
      />
    </>
  );
};

export default ProfileSettings;
